import React, { FunctionComponent } from 'react';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconEye: FunctionComponent<BrassIconProps> = (props: BrassIconProps) => (
  <BrassIcon {...props} icon={faEye} />
);

export { BrassIconEye };
